import Constants from '../actions/types';

const initialState = {
  valueMergeOperations: [],
  loading: false,
  message: null,
  severity: null
};

const valueMergeOperationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case Constants.VALUEMERGEOPERATIONS_GET_REQUEST: {
      const newState = {
        ...state,
        loading: true
      };

      return newState;
    }

    case Constants.VALUEMERGEOPERATIONS_GET_SUCCESS: {
      const newState = {
        ...state,
        valueMergeOperations: action.payload,
        loading: false
      };

      return newState;
    }

    case Constants.VALUEMERGEOPERATIONS_GET_FAILURE: {
      const newState = {
        valueMergeOperations: [],
        message: action.payload,
        severity: 'error',
        loading: false
      };

      return newState;
    }

    case Constants.VALUEMERGEOPERATIONS_NOT_FOUND: {
      const newState = {
        ...state,
        valueMergeOperations: [],
        loading: false
      };

      return newState;
    }

    case Constants.VALUEMERGEOPERATIONS_DELETE_FAILURE: {
      const newState = {
        ...state,
        message: action.payload,
        severity: 'error',
        loading: false
      };

      return newState;
    }

    case Constants.VALUEMERGEOPERATIONS_REVERSE_FAILURE: {
      const newState = {
        ...state,
        message: action.payload,
        severity: 'error',
        loading: false
      };

      return newState;
    }

    case Constants.VALUEMERGEOPERATIONS_SAVE_FAILURE: {
      const newState = {
        ...state,
        message: action.payload,
        severity: 'error',
        loading: false
      };

      return newState;
    }

    case Constants.VALUEMERGEOPERATIONS_SAVE_SUCCESS: {
      const newState = {
        ...state,
        message: 'Initiated the value merge operation successfully',
        severity: 'info',
        loading: false
      };

      return newState;
    }

    case Constants.VALUEMERGEOPERATIONS_CLEAR_ERROR: {
      const newState = {
        ...state,
        message: null,
        severity: null
      };

      return newState;
    }

    case Constants.FIELDVALUEINDEXES_CLEAR_ERROR: {
      const newState = {
        ...state,
        message: null,
        severity: null
      };

      return newState;
    }

    default: {
      return state;
    }
  }
};

export default valueMergeOperationsReducer;
